import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Wrapping component for help content layout
 * @param {*} props
 * @returns {ReactElement} Layout to standardize help content display
 */
const HelpLayout = ({ title, ...props }) => {
	return (
		<Box>
			<Typography
				gutterBottom
				variant='h6'
				component='div'
				color='primary'
			>
				{title}
			</Typography>
			{props.children}
		</Box>
	);
};

HelpLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string,
};

export default HelpLayout;
